// extracted by mini-css-extract-plugin
export var firmConfirmation = "firm-confirmation__HEV1";